import { render, staticRenderFns } from "./ProducedProduct.vue?vue&type=template&id=7c1cbaba&"
import script from "./ProducedProduct.vue?vue&type=script&lang=ts&"
export * from "./ProducedProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports